import React, { useState, useEffect } from "react";
import { Form } from 'react-bootstrap';
import { toast } from "react-toastify";
import AuthService from 'services/auth.service';
import UserService from 'services/user.service';
import ProfileSectionCard from "./ProfileSectionCard";

const TeleconsultSettings = ({ profile, searchDocId, initialTeleconsultEnabled, isReadOnly=false }) => {
  const currentUser = AuthService.getCurrentUser();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isToggling, setIsToggling] = useState(false);

  useEffect(() => {
    setIsEnabled(initialTeleconsultEnabled || false);
  }, [initialTeleconsultEnabled]);

  const handleToggle = async () => {
    const newValue = isEnabled ? "0" : "1";
    setIsToggling(true);

    try {
      const data = await UserService.toggleTeleconsult(searchDocId, newValue);
      setIsEnabled(data.teleconsult_enabled);
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setIsToggling(false);
    }
  };

  return (
    <ProfileSectionCard title="Availability Settings" showEditButton={false}>
      <div className="profile-info-group pt-10">
        <div className="profile-info-row">
          <div className="profile-info-label flex-grow-1">
            <h5>Teleconsult</h5>
            <p className="mb-0">Allow patients to book and consult with you through online video consultations.</p>
            {!profile?.enable_chat && (
              <small className="text-danger d-block mt-1">Chat feature not enabled yet. Please contact an admin to enable your chat feature.</small>
            )}
          </div>
            <Form.Check 
              type="switch" 
              id="teleconsult-toggle-switch" 
              label="" 
              checked={isEnabled}
              onChange={handleToggle} 
              disabled={isReadOnly || isToggling || !profile?.enable_chat} 
              className="ml-4 switch-toggle" 
              style={{ transform: 'scale(1.5)' }} 
            />
        </div>
      </div>
    </ProfileSectionCard>
  );
};

export default TeleconsultSettings;